import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-strelci-filter-dialog',
  templateUrl: './strelci-filter-dialog.component.html',
  styleUrls: ['./strelci-filter-dialog.component.scss']
})
export class StrelciFilterDialogComponent {
  @Output() apply = new EventEmitter<any>();
  filters = {
    member_id: '',
    full_name: '',
    gender: '',
    club_name: '',
    club_code: ''
  };

  onApply() {
    this.apply.emit(this.filters);
  }

  onReset() {
    this.filters = {
      member_id: '',
      full_name: '',
      gender: '',
      club_name: '',
      club_code: ''
    };
    this.apply.emit(this.filters);
  }
}